import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Typography } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
import { Link } from "../Link";
const TopInfoBarContainer = styled("div")(({ theme }) => ({
    boxSizing: "border-box",
    backgroundColor: theme.palette.green10.main,
    color: theme.palette.primaryWhiteText.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: convertPxToRem(48),
    padding: convertPxToRem(16),
}));
export const TopInfoBar = ({ linkProps, message, testId }) => (_jsx(TopInfoBarContainer, Object.assign({ "data-testid": testId }, { children: _jsxs(Typography, Object.assign({ variant: "smallText" }, { children: [message, linkProps && (_jsxs(_Fragment, { children: ["\u00A0\u2014\u00A0", _jsx(Link, Object.assign({}, linkProps, { colorVariant: "inverted", underline: "always", variant: "smallTextStrong" }))] }))] })) })));
